import { contextFactory } from '@frontend/design-system';
import { UseWritebackWidgetProvidersResults } from './hooks/useWritebackWidgetProviders';

export const [WritebackWidgetContext, useWritebackWidgetContext] = contextFactory<UseWritebackWidgetProvidersResults>();
